/*********************** Custom JS for Boost AI Search & Discovery  ************************/
let changedProductImageBySwatch = false;
const updateProductItem = componentRegistry => {
    componentRegistry.useComponentPlugin("ProductItem", {
        name: "hide swatch if one variant",
        enabled: true,
        apply: () => ({
            afterRender(element) {
                let productData = element.getParams().props.product;
                let productItem = document.querySelector('[id="' + productData.id + '"]');
                // Start Boost213361
                if (productData.title.includes("Bundle")) {
                    // productItem.classList.add('boost-bundle');
                }
                //End Boost 213361
                if (!(productData.variants.length > 1) && productItem?.querySelector(".boost-sd__product-swatch")) {
                    productItem.querySelector(".boost-sd__product-swatch").style.display = "none";
                }
                var saleProduct = productItem.querySelector(".boost-sd__product-label--sale");
                const checkBundleCollection = window.location.pathname.includes("collections/bundles");
                if (!checkBundleCollection) {
                    const saleSavingsText = productItem.querySelector(".boost-sd__product-price-saving");
                    if (saleSavingsText) {
                        saleSavingsText.classList.add("hide");
                    }
                }
                if (checkBundleCollection && saleProduct) {
                    saleProduct.classList.add("boost-sd-sale-bundle-custom");
                    // var percentSale = productData.percent_sale_min;
                    let priceOff = productData.compare_at_price_max - productData.price_max;
                    var savingTextCustom = `Bundle Savings — $ {
                        formatMoney(priceOff,
                            undefined,
                            true)
                    }

                    OFF`;
                    // CUSTOM ADDING A TOP SAVINGS BADGE FOR MOBILE
                    let topSavingText = document.createElement("div");
                    topSavingText.innerHTML = savingTextCustom;
                    topSavingText.classList.add("boost-sd__product-price-saving-top");
                    const productTitle = productItem.querySelector(".boost-sd__product-title");
                    let parentDiv = productTitle.parentNode;
                    // NODE BEING INSERTED APPEARING TWICE, USING THIS TO SHOW ONLY ONCE
                    if (!parentDiv.querySelector(".boost-sd__product-price-saving-top")) {
                        parentDiv.insertBefore(topSavingText, productTitle);
                    }
                    // END
                    var savingTextDefault = productItem.querySelector(".boost-sd__product-price-saving");
                    if (savingTextDefault) {
                        savingTextDefault.innerHTML = savingTextCustom;
                    }
                    productItem.querySelector(".boost-sd__product-label").style.display = "none";
                }
                // Start Boost 230471
                if (productData.tags.indexOf("pfs:label-New Arrival") > -1) {
                    productItem.classList.add("boost-sd-new-arrival");
                }
                // End Boost 230471
                // Start Boost 542213
                if (productData.tags.indexOf("holiday_discount") > -1) {
                    const holiday_discount_html = '<div class="boost-sd__custom-label-bottom"><div class="boost-sd__holiday_discount">% off at checkout</div></div>';
                    if (productItem.querySelector(".boost-sd__custom-label-bottom") == null) {
                        productItem.querySelector(".boost-sd__product-image").insertAdjacentHTML("beforeend", holiday_discount_html);
                    }
                }
                if (productData.tags.indexOf("most_gifted") > -1 && boostSDAppConfig.generalSettings.collection_handle !== "black-friday-b" && boostSDAppConfig.generalSettings.collection_handle !== "best-sellers-b") {
                    const most_gifted_html = '<div class="boost-sd__custom-label-bottom"><div class="boost-sd__most-gifted">Most Gifted</div></div>';
                    if (productItem.querySelector(".boost-sd__custom-label-bottom") == null) {
                        productItem.querySelector(".boost-sd__product-image").insertAdjacentHTML("beforeend", most_gifted_html);
                    }
                }
                if (productData.tags.indexOf("free_2_day_shipping") > -1) {
                    const free_2_day_shipping_html = '<div class="boost-sd__custom-label-bottom"><div class="boost-sd__free_2_day_shipping">Free 2 Day Shipping</div></div>';
                    if (productItem.querySelector(".boost-sd__custom-label-bottom") == null) {
                        productItem.querySelector(".boost-sd__product-image").insertAdjacentHTML("beforeend", free_2_day_shipping_html);
                    }
                }

                function showDemandBadge() {
                    const tags = productData.tags.map(tag => tag.toLowerCase());
                    const isHighestDemand = tags.includes("in_highest_demand");
                    const isHighDemand = tags.includes("in_high_demand");
                    const isLowDemand = tags.includes("in_low_demand");
                    const productImage = productItem.querySelector(".boost-sd__product-image");
                    // Define the numbers based on demand level
                    let inDemandBadgeNumber = "";
                    if (isHighestDemand) {
                        inDemandBadgeNumber = "20+";
                    } else if (isHighDemand) {
                        inDemandBadgeNumber = "10+";
                    } else if (isLowDemand) {
                        inDemandBadgeNumber = "5+";
                    }
                    const bannerContainerClasses = "banner-container tw-absolute tw-inset-0 tw-mx-auto tw-w-11/12 tw-h-full tw-flex tw-justify-center tw-items-center tw-pointer-events-none tw-z-[1]";
                    const bannerClasses = "tw-rounded-cs-md tw-backdrop-blur-sm tw-bg-gold/20 tw-text-grey_300 tw-w-full tw-text-center tw-gap-[.6rem] tw-flex tw-flex-col tw-justify-center tw-items-center tw-pt-[1rem] tw-pb-[1.2rem] lg:tw-px-[2.6rem]";
                    if (isHighestDemand || isHighDemand || isLowDemand) {
                        // Check if the banner already exists as Boost re-render tends to create duplicates
                        const existingBannerContainer = productItem.querySelector(".banner-container");
                        if (existingBannerContainer) return;
                        const bannerContainer = document.createElement("div");
                        bannerContainer.className = bannerContainerClasses;
                        productImage.appendChild(bannerContainer);
                        // Create In Demand Banner
                        const inDemandBanner = document.createElement("div");
                        inDemandBanner.id = "in-demand-banner-pdp";
                        inDemandBanner.className = bannerClasses;
                        inDemandBanner.innerHTML = '<p class="tw-flex tw-items-center tw-gap-[.6rem]"> <span>' + createCartIcon() + '</span> ' +
                                                    '<span class="tw-text-sm xl:tw-text-lg tw-font-semibold tw-uppercase" >in demand</span> </p> ' +
                                                    '<p class="tw-text-sm tw-font-semibold sm:tw-font-medium" > <span>' + inDemandBadgeNumber + '</span> ' +
                                                    '<span class="tw-hidden lg:tw-inline" >sold in the last 24 hrs</span> <span class="lg:tw-hidden" >sold recently</span> </p>';
                        bannerContainer.appendChild(inDemandBanner);
                        inDemandBanner.style.transition = "opacity 0.5s ease-in-out";
                        setTimeout(() => {
                            inDemandBanner.style.opacity = "1";
                            setTimeout(() => {
                                inDemandBanner.style.opacity = "0";
                                setTimeout(() => {
                                    bannerContainer.remove();
                                }, 500); // Wait for fade out animation to complete
                            }, 3000);
                        }, 1000);
                    }
                }

                function createCartIcon() {
                    return ` <svg xmlns="http://www.w3.org/2000/svg" width="19" height="20" viewBox="0 0 19 20" fill="none" > <path d="M0.635128 16.2592C0.635131 16.2592 0.635133 16.2591 0.635136 16.2591L1.39702 7.11204L1.39702 7.112C1.52108 5.62141 2.76726 4.47461 4.26361 4.47461H13.97C15.4664 4.47461 16.7126 5.62141 16.8366 7.112L16.8366 7.11204L17.5985 16.2592L17.5985 16.2593C17.7385 17.9357 16.4154 19.3741 14.7327 19.3746C14.7324 19.3746 14.7322 19.3746 14.7319 19.3746H3.50172C1.81889 19.3746 0.495738 17.9362 0.635128 16.2592Z" stroke="#43413E" stroke-width="1.25" stroke-miterlimit="10" /> <mask id="path-2-inside-1_5275_7549" fill="white" > <path d="M13.3419 7.70114V4.2618C13.3419 1.90809 11.4339 0 9.08015 0C6.72645 0 4.81836 1.90809 4.81836 4.2618V7.70114" /> </mask> <path d="M12.0919 7.70114C12.0919 8.39149 12.6516 8.95114 13.3419 8.95114C14.0323 8.95114 14.5919 8.39149 14.5919 7.70114H12.0919ZM3.56836 7.70114C3.56836 8.39149 4.128 8.95114 4.81836 8.95114C5.50872 8.95114 6.06836 8.39149 6.06836 7.70114H3.56836ZM14.5919 7.70114V4.2618H12.0919V7.70114H14.5919ZM14.5919 4.2618C14.5919 1.21773 12.1242 -1.25 9.08015 -1.25V1.25C10.7435 1.25 12.0919 2.59844 12.0919 4.2618H14.5919ZM9.08015 -1.25C6.03609 -1.25 3.56836 1.21773 3.56836 4.2618H6.06836C6.06836 2.59844 7.4168 1.25 9.08015 1.25V-1.25ZM3.56836 4.2618V7.70114H6.06836V4.2618H3.56836Z" fill="#43413E" mask="url(#path-2-inside-1_5275_7549)" /> </svg> `;
                }
                showDemandBadge();
            },
        }),
    });
};
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([updateProductItem, ]);
const formatMoney = (money, format, withoutTrailingZeros) => {
    if (typeof format == "undefined") format = boostSDAppConfig.shop.money_format;
    if (format == "money_with_currency") format = boostSDAppConfig.shop.money_format_with_currency;
    if (typeof withoutTrailingZeros == "undefined") var withoutTrailingZeros = false;
    // if (typeof Shopify.formatMoney === 'function') { return Shopify.formatMoney(money, format); }
    if (typeof money == "string") {
        money = money.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || "${{amount}}";

    function defaultOption(opt, def) {
        return typeof opt == "undefined" ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ",");
        decimal = defaultOption(decimal, ".");
        if (isNaN(number) || number == null) {
            return 0;
        }
        number = parseFloat(number).toFixed(precision);
        var parts = number.split(".");
        var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var money = parts[1] ? decimal + parts[1] : "";
        return withoutTrailingZeros == true ? (dollars + money).replace(/((\,00)|(\.00))$/g, "") : dollars + money;
    }
    var matches = formatString.match(placeholderRegex);
    var match = matches && matches.length > 1 ? matches[1] : "";
    switch (match) {
        case "amount":
            value = formatWithDelimiters(money, 2);
            break;
        case "amount_no_decimals":
            value = formatWithDelimiters(money, 0);
            break;
        case "amount_with_comma_separator":
            value = formatWithDelimiters(money, 2, ".", ",");
            break;
        case "amount_no_decimals_with_comma_separator":
            value = formatWithDelimiters(money, 0, ".", ",");
            break;
        case "amount_with_space_separator_no_comma":
            value = formatWithDelimiters(money, 2);
            break;
        case "amount_no_decimals_with_space_separator":
            value = formatWithDelimiters(money, 0, " ", ".");
            break;
        default:
            value = formatWithDelimiters(money, 2);
            break;
    }
    formatString = formatString.replace(placeholderRegex, value);
    return formatString;
};
/*********************** Custom JS for Boost AI Search & Discovery  ************************/
const customize = {
    productSwatches: componentRegistry => {
        componentRegistry.useComponentPlugin("ProductSwatch", {
            name: "ProductSwatchOption - Add Class SoldOut for swatches",
            apply: () => ({
                props: props => {
                    const onSelect = props.onSelect;
                    props.onSelect = (value, image) => {
                        changedProductImageBySwatch = true;
                        onSelect(value, image);
                        setTimeout(() => (changedProductImageBySwatch = false), 200);
                    };
                    return props;
                },
                afterRender(element) {
                    try {
                        const data = element.getParentElm()?.getParentElm()?.getParams()?.props?.product || element.getParentElm()?.getParentElm()?.getParams()?.props?.productData || element.getParentElm()?.getParentElm()?.getParams()?.props?.data;
                        const props = element.getParams().props;
                        const values = props.options;
                        const swatchElm = element.getRootElm();
                        // console.log(element, element.getParams(), props);
                        if (values && values.length > 0 && !props.hasOwnProperty("isQuickView")) {
                            let index = 0;
                            let titleSwatchHtml = `<div class="boost-sd-swatch--title" >$ {
                                values[0].label
                            }

                            </div>`;
                            let swatchOptionElms = swatchElm.querySelectorAll(".boost-sd__product-swatch-option");
                            Array.from(swatchOptionElms).forEach((opt, idx) => {
                                if (opt.classList.contains("boost-sd__product-swatch-option--selected")) {
                                    index = idx;
                                    titleSwatchHtml = `<div class="boost-sd-swatch--title" >$ {
                                            values[idx].label
                                        }

                                        </div>`;
                                }
                            });
                            if (!swatchElm.querySelector(".boost-sd-swatch--title")) {
                                swatchElm.insertAdjacentHTML("beforeend",
                                    titleSwatchHtml);
                            } else {
                                swatchElm.querySelector(".boost-sd-swatch--title").innerHTML = values[index].label;
                            }
                        }
                    } catch (error) {
                        console.log(error);
                    }
                },
            }),
        });
    },
};
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.productSwatches, ]);
const customizeQuickview = {
    updateQuickViewOption: componentRegistry => {
        componentRegistry.useComponentPlugin("QuickView", {
            name: "Modify Quickview Option Background",
            enabled: true,
            apply: () => ({
                afterRender(element) {
                    let productData = element.getParams()?.props?.productData || element.getParams()?.props?.product || element.getParams()?.props?.data; // Get product data
                    if (productData) {
                        const sizeObject = productData.options_with_values.find(item => item.name === "size");
                        const sizeLength = sizeObject ? sizeObject.values.length : 0;
                        let optionSwatches = document.querySelectorAll(".boost-sd__quick-view .boost-sd__product-swatch");
                        if (sizeLength == 1 && optionSwatches.length > 1) {
                            var optionSizeSwatches = optionSwatches[1];
                            optionSizeSwatches.classList.add("boost-sd-custom-quick-view-swatches");
                        }
                    }
                },
            }),
        });
    },
};
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customizeQuickview.updateQuickViewOption, ]);
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([componentRegistry => {
    componentRegistry.useComponentPlugin("QuickView.ProductSwatch.ProductSwatchOption", {
        name: "Show product image in quick view #224829",
        apply: () => ({
            afterRender: element => {
                try {
                    const swatchOptionType = "material";
                    const propLabel = element.getParentElm()?.getParams()?.props?.label;
                    console.log(propLabel);
                    const productData = componentRegistry?.getNearestParentElm(element, "QuickView")?.getParams()?.props?.productData;
                    const swatchElmLabel = element.getRootElm()?.querySelector(".boost-sd__radio-label");
                    if (propLabel?.toLowerCase() === swatchOptionType.toLowerCase() && swatchElmLabel) {
                        swatchElmLabel.classList.add("boost-sd__product-swatch-option-" + swatchOptionType);
                        const fileUrl = boostSDAppConfig.generalSettings.file_url.split("?");
                        const swatchImgSrc = fileUrl[0] + slugify(element.getParams()?.props?.value) + ".png";
                        if (swatchImgSrc) {
                            swatchElmLabel.style.backgroundImage = `url(${swatchImgSrc})`;
                        }
                    }
                } catch (error) {
                    console.warn(error);
                }
            },
        }),
    });
    componentRegistry.useComponentPlugin("PaginationInfiniteScroll", {
        name: "PaginationInfiniteScroll",
        apply: () => ({
            props(props) {
                const urlParams = new URLSearchParams(window.location.search);
                const pageValue = urlParams.get("page") || 1;
                sessionStorage.setItem("boostSDCurrentNextPage", pageValue);
                return props;
            },
        }),
    });
}, ]);

function slugify(text) {
    if (text == null || typeof text == "object") return "";
    if (typeof text != "string") {
        if (typeof text.toString != "function") {
            return "";
        } else {
            text = text.toString();
        }
    }
    text = text.toLowerCase();
    // Remove Latin
    var from = "àáäâãèéëêẽìíïîĩòóöôõùúüûũñç·/_,:;";
    var to = "aaaaaeeeeeiiiiiooooouuuuunc--_---";
    for (var i = 0, l = from.length; i < l; i++) text = text.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
    // Remove Czech, Finnish special characters
    var specialCzechChars = "ÁáÄäČčĎďÉéěÍíŇňÓóÖöŘřŠšŤťÚúůÝýŽž";
    var asciiCzechChars = "AaAaCcDdEeeIiNnOoOoRrSsTtUuuYyZz";
    var specialCzechCharsLength = specialCzechChars.length;
    for (var j = 0; j < specialCzechCharsLength; j++) {
        text = text.replace(new RegExp(specialCzechChars.charAt(j), "g"),
            asciiCzechChars.charAt(j));
    }
    // Remove Norway special characters
    var specialNorwayChars = "ÆæØøÅå";
    var asciiNorwayChars = ["AE",
        "ae",
        "O",
        "o",
        "A",
        "a"
    ];
    var specialNorwayCharsLength = specialNorwayChars.length;
    for (var k = 0; k < specialNorwayCharsLength; k++) {
        text = text.replace(new RegExp(specialNorwayChars.charAt(k), "g"),
            asciiNorwayChars[k]);
    }
    // Remove quotes
    text = text.replace(/'/g, "").replace(/"/g, "");
    return text.replace(/[\s\/]+/g, "-") // Replace spaces with -
        .replace(/[`~ !@#$%^&*()|+\-=?; :'",.<>\{\}\[\]\\\/]/g, "-") // Replace all special characters with -
        .replace(/\-\-+/g, "-") // Replace multiple - with single -
        .replace(/^-+/, "") // Trim - from start of text
        .replace(/-+$/, ""); // Trim - from end of text
}
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([componentRegistry => {
    const changeProductImage = {
        name: "Change Product Image",
        apply() {
            return {
                props(props, element) {
                    const productData = element.getParentElm().getParentElm().getParams().props.product;
                    if (!changedProductImageBySwatch && boostSDAppConfig.generalSettings.collection_id == 296791244975 && boostSDAppConfig.generalSettings.collection_handle == "emerald-jewelry") {
                        let emerald_image = productData.metafields.find(e => e.namespace == "custom" && e.key == "emerald_image");
                        if (typeof emerald_image != "undefined") {
                            props.images[0] = emerald_image.value;
                        }
                    }
                    if (!changedProductImageBySwatch && boostSDAppConfig.generalSettings.collection_id == 157919215753 && boostSDAppConfig.generalSettings.collection_handle == "rhodium-jewelry") {
                        let rhodium_image = productData.metafields.find(e => e.namespace == "custom" && e.key == "rhodium_image");
                        if (typeof rhodium_image != "undefined") {
                            props.images[0] = rhodium_image.value;
                        }
                    }
                    if (!changedProductImageBySwatch && boostSDAppConfig.generalSettings.collection_id == 330369958063 && boostSDAppConfig.generalSettings.collection_handle == "silver-jewelry") {
                        let silver_image = productData.metafields.find(e => e.namespace == "custom" && e.key == "silver_image");
                        if (typeof silver_image != "undefined") {
                            props.images[0] = silver_image.value;
                        }
                    }
                    if (!changedProductImageBySwatch && boostSDAppConfig.generalSettings.collection_id == 349146546351 && boostSDAppConfig.generalSettings.collection_handle.indexOf('silver-') !== -1) {
                        let silver_image = productData.metafields.find(e => e.namespace == "custom" && e.key == "silver_image");
                        if (typeof silver_image != "undefined") {
                            props.images[0] = silver_image.value;
                        }
                    }
                    if (!changedProductImageBySwatch && boostSDAppConfig.generalSettings.collection_id == 330443751599 && boostSDAppConfig.generalSettings.collection_handle == "silver-and-rhodium-jewelry") {
                        let silver_image = productData.metafields.find(e => e.namespace == "custom" && e.key == "silver_image"),
                            rhodium_image = productData.metafields.find(e => e.namespace == "custom" && e.key == "rhodium_image");
                        if (typeof silver_image != "undefined") {
                            props.images[0] = silver_image.value;
                        } else if (typeof rhodium_image != "undefined") {
                            props.images[0] = rhodium_image.value;
                        }
                    }
                    return props;
                },
            };
        },
    };
    componentRegistry.useComponentPlugin("ProductImage", changeProductImage);
}, ]);